
import React, { FC, useState } from 'react';
import styled from '@emotion/native';
import { Spacer, Modal, Title } from '@components/1-atoms';

// import { BackButton, IconButton } from '@components/2-molecules/';
// import BackButton from './Buttons/BackButton';
// import IconButton from './Buttons/IconButton';
import { BackButton, IconButton } from '@components/2-molecules/Buttons';

import MenuIcon from '@assets/icons/menu';
import { View } from 'react-native';

const Container = styled.View`
  position: relative;
  top: 0;
  left: 0;
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  padding: 0;
  width: 100%;
  justify-content: space-between;
  height: ${({ theme }: any) => theme.headerHeight + 'px'};
`;


const Left = styled.View`
  flex-direction: row;
`;
const Right = Left;

type Props = {
  style?: object;
  title: string;
  left?: React.ReactNode | any;
  right?: React.ReactNode | any;
  menu?: React.ReactNode | any;
  menuIcon?: React.ReactNode | any;
  
  dontGoBack?: boolean;
}

const PageHeader: FC<Props> = ({ left, right, title, style, menu, dontGoBack, menuIcon, ...props }) => {
  menuIcon = menuIcon || <MenuIcon />;

  const [showMenu, setShowMenu] = useState(false);
  const toggleMenu = () => setShowMenu(!showMenu);

  return (
  <View>
    <Container style={style}>
      <Left>
        {!dontGoBack && <BackButton />}
        {left}
        <Spacer w={1} />
        
        <Title color='#FFF' bold>{title}</Title>
      </Left>

      <Right>
        {right}
        {menu && <IconButton transparent icon={menuIcon} onPress={toggleMenu}/>}
      </Right>
    </Container>
    
    <Modal visible={showMenu} title='Menu' onClose={toggleMenu}>
        {menu}
    </Modal>
    </View>
  );
};

export default PageHeader;